import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SuccessCircleBoldIcon } from '@pattern-library/icon';
import Card from './Card';
const propTypes = {
  /**
   * Enables or disables the border around the card
   */
  border: PropTypes.bool,
  /**
   * Card content.
   * Avoid block and interactive elements and use phrasing elements instead.
   * https://www.w3.org/TR/2012/WD-html5-20120329/the-button-element.html#the-button-element
   **/
  children: PropTypes.node.isRequired,
  /**
   * Function that runs on checkbox click. If provided, the checked state must be controlled by the parent
   * and provided through the `initialValue` prop.<br />
   * `(children, isChecked) => void`
   **/
  handleCardSelectChange: PropTypes.func,
  /**
   * the checkbox's ID
   **/
  id: PropTypes.string.isRequired,
  /**
   * Controls the checked state of the checkbox
   **/
  initialValue: PropTypes.bool,
  /**
   * Value for `data-qa` HTML attribute added to the checkbox for automation testing
   **/
  qaId: PropTypes.string
};
const defaultProps = {
  border: true,
  initialValue: false,
  qaId: ''
};
class CardSelect extends Component {
  constructor(props) {
    super(props);
    this.toggleCardSelectChange = () => {
      const {
        handleCardSelectChange,
        children
      } = this.props;
      if (handleCardSelectChange !== null && handleCardSelectChange !== undefined) {
        handleCardSelectChange(children, this.state.isChecked);
      } else {
        this.setState({
          isChecked: !this.state.isChecked
        });
      }
    };
    this.state = {
      isChecked: this.props.initialValue
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.initialValue !== prevProps.initialValue) {
      this.setState({
        isChecked: this.props.initialValue
      });
    }
  }
  render() {
    const {
      id,
      children,
      qaId,
      border
    } = this.props;
    const {
      isChecked
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "asc-card-select"
    }, /*#__PURE__*/React.createElement("div", {
      className: "asc-card-select-spacer",
      "aria-hidden": "true"
    }, children), /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: id,
      name: id,
      onChange: this.toggleCardSelectChange,
      checked: isChecked,
      "data-qa": qaId,
      className: "asc-card-select-input"
    }), /*#__PURE__*/React.createElement(Card, {
      backgroundColor: "white",
      border: border,
      padding: false,
      className: "asc-card-select-label"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: id
    }, isChecked ? /*#__PURE__*/React.createElement("span", {
      className: "asc-card-selected-indicator asc-card-selected-indicator--checked"
    }, /*#__PURE__*/React.createElement(SuccessCircleBoldIcon, {
      color: "brand-link"
    })) : /*#__PURE__*/React.createElement("span", {
      className: "asc-card-selected-indicator asc-card-selected-indicator--not-checked"
    }), children)));
  }
}
CardSelect.defaultProps = defaultProps;
CardSelect.propTypes = propTypes;
export default CardSelect;